import { BrowserPrint } from './BrowserPrint-3.1.250.min.js';
import { Zebra } from './BrowserPrint-Zebra-1.1.250.min.js';

import * as ZPLTemplate from './templates/index.zpl.js';

// promisify callback functions
function getDefaultDevice(type = 'printer') {
  return new Promise((resolve, reject) => {
    BrowserPrint.getDefaultDevice(
      type,
      (device) => resolve(device),
      (error) => reject(error),
    );
  });
}

function getLocalDevices() {
  return new Promise((resolve, reject) => {
    BrowserPrint.getLocalDevices(
      (deviceList) => resolve(deviceList),
      (error) => reject(error),
    );
  });
}

function print(device, zplTemplate) {
  return new Promise((resolve, reject) => {
    device.send(
      zplTemplate,
      (success) => resolve(success),
      (error) => reject(error),
    );
  });
}

function getPrinterStatus(device) {
  const printer = new Zebra.Printer(device);

  return new Promise((resolve, reject) => {
    printer.getStatus(
      (status) => resolve(status),
      (error) => reject(error),
    );
  });
}

export {
  getDefaultDevice,
  getLocalDevices,
  getPrinterStatus,
  print,
  ZPLTemplate,
};
